/**
 * Editorial section label — a small serif-mono kicker with a hairline rule.
 * (Deliberately does NOT display any "§ 01" numbering before the label.)
 */
export function SectionLabel({ label, align = "left" }) {
    return (
        <div className={`flex items-center gap-3 mb-3 ${align === "center" ? "justify-center" : ""}`}>
            <span className="h-px w-6 bg-foreground/50 hidden sm:inline-block" />
            <span className="font-mono text-[11px] uppercase tracking-[0.24em] text-muted-foreground">{label}</span>
            <span className="h-px flex-1 bg-border/70" />
        </div>
    );
}
